import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { ArrowRightIcon, MapPinIcon, UsersIcon } from 'lucide-react';
import { HPEvent } from '../types';
interface EventCardProps {
  event: HPEvent;
  featured?: boolean;
}
export function EventCard({
  event,
  featured = false
}: EventCardProps) {
  const date = new Date(event.date);
  if (featured) {
    return <article className="group grid overflow-hidden rounded-xl border border-paper-line bg-white md:grid-cols-2" data-id="element-93" data-mp="1xrcsz72gdeup">
        <div className="relative aspect-[4/3] overflow-hidden md:aspect-auto" data-id="element-94" data-mp="1stkrpmfx4gdu">
          <img src={event.image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-95" data-mp="27hfmd8dhkutk" />
          <span className="absolute left-4 top-4 rounded-full bg-signal px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-white" data-id="element-96" data-mp="1f1ek4oqtzhq0">
            {event.format}
          </span>
        </div>
        <div className="flex flex-col justify-between p-7 sm:p-10" data-id="element-97" data-mp="37of5pkk2adnp">
          <div data-id="element-98" data-mp="37m2qhf5ouhec">
            <p className="eyebrow text-ink-muted" data-id="element-99" data-mp="37mcewyb34ghx">
              {format(date, 'EEEE d MMMM yyyy')} · {event.city}
            </p>
            <h3 className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-100" data-mp="3hdqboybnj27d">
              {event.title}
            </h3>
            <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-101" data-mp="3lhob7a4w2f0y">{event.strapline}</p>
            <p className="mt-5 text-sm leading-relaxed text-ink-muted line-clamp-3" data-id="element-102" data-mp="2or5j5ujfwk28">{event.description}</p>
          </div>
          <div className="mt-8" data-id="element-103" data-mp="2tq8olg3c0saq">
            <dl className="flex flex-wrap gap-x-8 gap-y-2 border-t border-paper-line pt-5 text-sm text-ink-muted" data-id="element-104" data-mp="2xppx6ie225k4">
              <div className="flex items-center gap-2" data-id="element-105" data-mp="32pvi7fptktt8">
                <MapPinIcon className="h-4 w-4 text-signal" aria-hidden="true" data-id="element-106" data-mp="czs3w91kz6e4" />
                <dd data-id="element-107" data-mp="d24m8nb93irp">{event.venue}</dd>
              </div>
              <div className="flex items-center gap-2" data-id="element-108" data-mp="hxtm6rr6n1oj">
                <UsersIcon className="h-4 w-4 text-signal" aria-hidden="true" data-id="element-109" data-mp="2e1zqmhevceix" />
                <dd data-id="element-110" data-mp="2e42qdt5tpm0u">{event.capacity} places</dd>
              </div>
            </dl>
            <Link to={`/events/${event.slug}`} className="mt-6 inline-flex items-center gap-2 rounded-full bg-signal px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-signal-deep" data-id="element-111" data-mp="2a04r9igi0b7s">
              Register to attend
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="1vcjoxqrg6g0x" />
            </Link>
          </div>
        </div>
      </article>;
  }
  return <article className="group flex flex-col overflow-hidden rounded-xl border border-paper-line bg-white transition-colors hover:border-signal/40" data-id="element-113" data-mp="1qaknimf9pt6m">
      <div className="relative aspect-[16/10] overflow-hidden" data-id="element-114" data-mp="209jtfx8nfapx">
        <img src={event.image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-115" data-mp="1ckqya2zup6wd" />
        <span className="absolute left-4 top-4 rounded-full bg-signal px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-white" data-id="element-116" data-mp="17k36hf3ssm13">
          {event.format}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6" data-id="element-117" data-mp="3o22etke0xs2u">
        <p className="eyebrow text-ink-muted" data-id="element-118" data-mp="3a9mamg9dzo0c">
          {format(new Date(event.date), 'd MMM yyyy')} · {event.city}
        </p>
        <h3 className="mt-3 font-display text-2xl font-semibold leading-snug text-ink" data-id="element-119" data-mp="3eafyj9mtx2t8">{event.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-muted" data-id="element-120" data-mp="5v5ye72i27o3">{event.strapline}</p>
        <Link to={`/events/${event.slug}`} className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-signal transition-colors group-hover:text-signal-deep" data-id="element-121" data-mp="asobm9njv91w">
          Register to attend
          <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-122" data-mp="2hjx7nxd49dw3" />
        </Link>
      </div>
    </article>;
}